import { Handle } from "react-flow-renderer";
import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 43px;
  height: 43px;
  box-sizing: border-box;
  cursor: auto;
  border-radius: 4px;
  transform: rotate(-45deg);
  align-items: center;
  align-self: center;
  justify-content: center;
  display: flex;
  box-shadow: 0 0 0 1.2px #42464c;
  &.critical {
    border: 4px solid #d93333 !important;
  }

  ${({ status }) =>
    status === "doing"
      ? css`
          background-color: #f9e169;
        `
      : status === "pending"
      ? css`
          background-color: #fff;
        `
      : status === "done"
      ? css`
          background-color: #a0f69e;
        `
      : css`
          background-color: #fff;
        `}

  path {
    stroke: #42464c;
    stroke-width: 0.4px;
  }
`;

export const ParallelEndInside = styled.div`
  width: 35px;
  height: 35px;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0 0 0 0.8px #42464c;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HandleStyle = styled(Handle)`
  width: 8px;
  height: 8px;
`;
